import { COLOR, CosunoLogo, PremiumBadge, useQueryMatches } from '@cosuno/cosuno-ui';

import { LogoContainer, SidebarTopContainer } from './Styles';

export const PremiumLogo = () => {
  const { isDesktop } = useQueryMatches();
  return (
    <SidebarTopContainer>
      <LogoContainer>
        <CosunoLogo color={isDesktop ? COLOR.white : COLOR.brand} width={isDesktop ? 220 : 200} />
        <PremiumBadge />
      </LogoContainer>
    </SidebarTopContainer>
  );
};
